/* eslint-disable radix */
import { I18n } from 'react-redux-i18n';
import RestService from '../services/rest';

async function createClient({
  clientId,
  status,
  freight,
  bu,
  locationId,
  places,
  pricePolicy,
  purpose,
  buyButtonLabel,
  deposit,
  mainDeposit,
  emails,
  fileEmailXml,
  fileEmailCsv,
  fileEmailPdf,
  fileEmailJson,
  displayClientDescription,
  showContractProductWithoutPrice,
  nickname,
  allowSellSpotItensWithoutStock,
  limits,
  clientWithdraw,
  minimumPurchase,
  minimumProduct,
  orderType,
  deliveryAddressType,
  internalDeliveryAddress,
  autoBilling,
  customerUnit,
  punchoutRule,
  punchoutN2Rule,
  punchoutVendorId,
  newItemVendor,
  newItemContract,
  productCatalogPunchout,
  punchoutCatalogName,
  newLogoUrl,
  projectsForIntegrators,
}) {
  return RestService.postAuthenticated('panel/clients/create', {
    clientId,
    status,
    freight,
    bu,
    locationId,
    places,
    pricePolicy,
    purpose,
    buyButtonLabel,
    deposit,
    mainDeposit,
    emails,
    fileEmailXml,
    fileEmailCsv,
    fileEmailPdf,
    fileEmailJson,
    displayClientDescription,
    showContractProductWithoutPrice,
    clientWithdraw,
    nickname,
    allowSellSpotItensWithoutStock,
    limits,
    minimumPurchase,
    minimumProduct,
    orderType,
    deliveryAddressType,
    internalDeliveryAddress,
    autoBilling,
    customerUnit,
    punchoutRule,
    punchoutN2Rule,
    punchoutVendorId,
    newItemVendor,
    newItemContract,
    productCatalogPunchout,
    punchoutCatalogName,
    newLogoUrl,
    projectsForIntegrators,
  });
}

async function updateClient({
  clientId,
  status,
  freight,
  bu,
  locationId,
  places,
  pricePolicy,
  purpose,
  buyButtonLabel,
  deposit,
  mainDeposit,
  emails,
  fileEmailXml,
  fileEmailCsv,
  fileEmailPdf,
  fileEmailJson,
  displayClientDescription,
  showContractProductWithoutPrice,
  clientWithdraw,
  nickname,
  allowSellSpotItensWithoutStock,
  limits,
  minimumPurchase,
  minimumProduct,
  orderType,
  deliveryAddressType,
  internalDeliveryAddress,
  autoBilling,
  customerUnit,
  projectsForIntegrators,
  punchoutRule,
  punchoutN2Rule,
  punchoutVendorId,
  newItemVendor,
  newItemContract,
  productCatalogPunchout,
  punchoutCatalogName,
  newLogoUrl,
  punchoutUserIndicatorParameters,
  punchoutUserIndicatorEmail,
  punchoutUserIndicatorName,
  punchoutUserIndicatorPhone,
  punchoutUserIndicatorUnit,
}) {
  return RestService.putAuthenticated('panel/clients/update', {
    clientId,
    status,
    freight,
    bu,
    locationId,
    places,
    pricePolicy,
    purpose,
    buyButtonLabel,
    deposit,
    mainDeposit,
    emails,
    fileEmailXml,
    fileEmailCsv,
    fileEmailPdf,
    fileEmailJson,
    displayClientDescription,
    showContractProductWithoutPrice,
    clientWithdraw,
    nickname,
    allowSellSpotItensWithoutStock,
    limits,
    minimumPurchase,
    minimumProduct,
    orderType,
    deliveryAddressType,
    internalDeliveryAddress,
    autoBilling,
    customerUnit,
    projectsForIntegrators,
    punchoutRule,
    punchoutN2Rule,
    punchoutVendorId,
    newItemVendor,
    newItemContract,
    productCatalogPunchout,
    punchoutCatalogName,
    newLogoUrl,
    punchoutUserIndicatorParameters,
    punchoutUserIndicatorEmail,
    punchoutUserIndicatorName,
    punchoutUserIndicatorPhone,
    punchoutUserIndicatorUnit,
  });
}

async function getClient(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/clients?limit=${limit}&skip=${skip}&search=${search || ''}&order=${order}&field=${field}`,
  );
}

async function searchSphereClient(limit, search) {
  return RestService.getAuthenticated(`panel/clients/search?limit=${limit}&search=${search}`);
}

async function getClientSettings(nameAbbr) {
  return RestService.getAuthenticated(`panel/clients/settings?nameAbbr=${nameAbbr}`);
}

async function getCsvClientsReport() {
  const response = await RestService.getAuthenticated('panel/clients/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'clients-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvUsersAccessReport(clientId, standardDays, iniDate, finDate) {
  const response = await RestService.getAuthenticated(
    `panel/clients/users/access/report/csv?clientId=${clientId}&standardDays=${standardDays}&iniDate=${iniDate}&finDate=${finDate}`,
    {
      responseType: 'blob',
    },
  );

  if (response.noData !== undefined && !response.noData) {
    return false;
  }
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = `clients-users-access-export-${standardDays === 1 ? 'standard-date' : 'between-dates'}.csv`;
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
  return true;
}

async function getCsvClientModel() {
  const response = await RestService.getAuthenticated('panel/clients/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Clientes CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvClients(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/clients/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}
async function customerProducts(spotCheck, contractCheck, clientId) {
  const response = await RestService.getAuthenticated(`panel/clients/customerProducts/csv?spotCheck=${spotCheck}&contractCheck=${contractCheck}&clientId=${clientId}`);
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = I18n.t('customerProducts');
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getAllClients() {
  return RestService.getAuthenticated('panel/clients/allList');
}

async function uploadClientLogo(file, name, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/clients/import/logo?&name=${name}&id=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

export default {
  createClient,
  getClient,
  getClientSettings,
  updateClient,
  searchSphereClient,
  getCsvClientsReport,
  getCsvClientModel,
  uploadCsvClients,
  getCsvUsersAccessReport,
  customerProducts,
  getAllClients,
  uploadClientLogo,
};
